<template>
  <v-container>
    <v-row dense>
      <v-col lg="6" md="8" sm="10">
        <v-card>
          <v-img v-if="takenTask.task.image.url" :src="takenTask.task.image.url"></v-img>
          <!--          {{ takenTask.task.image.url }}-->
          <v-card-title>
            <div>{{ takenTask.task.name }}</div>
          </v-card-title>
          <v-card-text>
            <div v-html="takenTask.task.description"></div>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text>
            <div class="font-weight-bold ml-8 mb-2">Шаги</div>

            <v-timeline align-top dense>
              <v-timeline-item v-for="message in takenTask.task.steps" :key="message.id" small>
                <div v-html="message.description"></div>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="6" md="8" sm="10">
        <v-card>
          <v-card-title>
            {{ takenTask.user_name }}
          </v-card-title>
          <v-card-subtitle v-if="takenTask.user_phone_number">
            <a :href="'tel:+7' + takenTask.user_phone_number">{{ takenTask.user_phone_number }}</a>
          </v-card-subtitle>
          <v-card-subtitle v-if="takenTask.user_region.key">
            {{ takenTask.user_region.title }}
          </v-card-subtitle>
          <v-card-text>
            <div v-html="reportText"></div>
            <v-divider></v-divider>
            <div>
              <v-subheader v-if="takenTask.meta">Опросник</v-subheader>
              <template v-for="(v, k) of takenTask.meta">
                <!--            <div :key="k + v + 'meta'">{{ k }} &#45;&#45; {{ v }}</div>-->
                <div :key="k + v + 'meta'">
                  {{ k }}
                  <v-rating length="5" :value="v"></v-rating>
                </div>
              </template>
            </div>
            <v-divider></v-divider>
            <v-list v-if="statuses.length > 0">
              <StatusListItem :status="statuses[0]"></StatusListItem>
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-title>Статусы</v-list-item-title>
                </template>
                <template v-for="status in statuses.slice(1)">
                  <StatusListItem :status="status"></StatusListItem>
                </template>
              </v-list-group>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="takenTask.status > 2" outlined color="success" @click="addApproveStatus"
              >Утвердить
            </v-btn>
            <v-btn
              v-if="takenTask.status > 2"
              outlined
              color="warning"
              @click="rejectDialog = !rejectDialog"
              >Отклонить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="rejectDialog" max-width="500">
      <v-card class="pa-2">
        <v-card-subtitle>Причина отклонения</v-card-subtitle>
        <v-card-text>
          <v-form ref="rejectForm">
            <v-textarea v-model="comment" :rules="rules.required"> </v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined color="success" @click="addRejectStatus">Отправить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { getCreateTakenTaskStatusResponse, getTakenTaskStatusesResponse } from '@/api/activist/task'
import StatusListItem from '@/components/StatusListItem'
import { StatusKind } from '@/api/status'
import forms from '@/mixins/forms'

function urlify(text) {
  const urlRegex = /(https?:\/\/[^\s]+)/g
  return text.replace(urlRegex, function (url) {
    return '<a href="' + url + '">' + url + '</a>'
  })
  // or alternatively
  // return text.replace(urlRegex, '<a href="$1">$1</a>')
}

export default {
  name: 'TakenTaskDetail',
  components: { StatusListItem },
  mixins: [forms],
  props: {
    takenTask: {
      type: Object,
      default: () => {
        return { id: '', task: { name: '', image: { url: '' } } }
      },
    },
  },
  data() {
    return {
      statuses: [],
      rejectDialog: false,
      comment: '',
    }
  },
  computed: {
    reportText() {
      return urlify(this.takenTask.report_text)
    },
  },
  mounted() {
    this.getStatuses()
  },
  methods: {
    getStatuses() {
      getTakenTaskStatusesResponse(this.axios, this.takenTask.id)
        .then((resp) => {
          this.$set(this, 'statuses', resp.data || [])
        })
        .catch((err) => {
          this.showSnackbar(err, 'error')
        })
    },
    addRejectStatus() {
      this.$log.debug(this.$refs.rejectForm.validate())
      if (!this.$refs.rejectForm.validate()) {
        this.showSnackbar(this.messages.needFillAllRequiredFields, 'error')
        return
      }
      this.addStatus({ kind: StatusKind.Rejected, comment: this.comment })
    },
    addApproveStatus() {
      this.addStatus({ kind: StatusKind.Approved })
    },
    addStatus(status) {
      getCreateTakenTaskStatusResponse(this.axios, this.takenTask.id, status)
        .then((resp) => {
          this.comment = ''
          this.rejectDialog = false
          if (this.$refs.rejectForm) {
            this.$refs.rejectForm.reset()
          }
          this.getStatuses()
          this.showSnackbar('Статус добавлен', 'success')
        })
        .catch((err) => {
          this.showSnackbar(err, 'error')
        })
    },
  },
}
</script>
